import GlobalFields from 'defs/ga/fields/global';
import VirtualPageViewFields from 'defs/ga/fields/virtualPageView';
import appConfig from 'helper/mapBackendConfig';

type TrackVirtualPageViewParams = {
	virtualPageTitle?: string;
	virtualPageUrl?: string;
	pageType: string;
	contentType: string;
	pnam: string;
	paid: string;
	pgc?: Array<string>;
	hrco?: number;
	lang: string;
	eid?: string;
	vlst?: boolean;
	mandant?: string;
	geschlecht?: 'male' | 'female' | '';
	originalLocation?: string;
};

const allowedAdditionalPageViewProps: Array<string> = [
	'coachProgId',
	'coachProgNm',
	'coachCardType',
	'coachProdNm',
	'coachProdId',
];

const getDefaultOriginalLocation = () =>
	[document.location.hostname, document.location.pathname, document.location.search].join('');

export const trackVirtualPageView = (params: TrackVirtualPageViewParams) => {
	const {
		virtualPageTitle,
		virtualPageUrl,
		paid,
		pgc,
		lang,
		eid,
		hrco, // => static 200 when reachable, 404 on not-found page
		vlst,
		mandant,
		geschlecht,
		originalLocation,
	} = params;

	const additionalProps = {};

	Object.keys(params)
		.map((additionalKey: string): string | void => {
			return !!~allowedAdditionalPageViewProps.indexOf(additionalKey) ? additionalKey : void 0;
		})
		.filter((val: string | void): boolean => Boolean(val))
		.forEach((key: string | void) => {
			if (key) {
				additionalProps[key] = params[key];
			}
		});

	return {
		...additionalProps,
		[GlobalFields.Event]: 'virtualPageView',
		[GlobalFields.VirtualPageTitle]: virtualPageTitle,

		[VirtualPageViewFields.SiteType]: 'responsive',
		[VirtualPageViewFields.PageType]: 'coach', // pageType || '',
		[VirtualPageViewFields.ContentType]: 'coach', // contentType || '',
		[VirtualPageViewFields.PageName]: virtualPageUrl || document.location,
		[VirtualPageViewFields.PageId]: paid || '',
		[VirtualPageViewFields.PageGroupCategory]: pgc || [],
		[VirtualPageViewFields.Language]: lang || appConfig.env.language || '',
		[VirtualPageViewFields.EnvironementId]: eid || 'production',
		[VirtualPageViewFields.HTTPResponseCode]: hrco || 200,
		[VirtualPageViewFields.VisitorLoginState]: !!vlst,
		[VirtualPageViewFields.Client]: mandant || 'impuls',
		[VirtualPageViewFields.Sex]: geschlecht || '',
		[VirtualPageViewFields.OriginalLocation]: originalLocation || getDefaultOriginalLocation(),
	};
};
